import type z from "zod";
import { FocusedContextSchema, SwitchFocusRequestSchema } from "@storytell/types";

// Response schema for obtaining the user's focused context
export const ObtainFocusedContextResponseSchema = FocusedContextSchema;
export type ObtainFocusedContextResponse = z.infer<typeof ObtainFocusedContextResponseSchema>;

// Request body schema for switching the user's focused context
export const SwitchFocusInputSchema = SwitchFocusRequestSchema;
export type SwitchFocusInput = z.infer<typeof SwitchFocusInputSchema>;

// Response schema for switching the user's focused context
export const SwitchFocusResponseSchema = FocusedContextSchema;
export type SwitchFocusResponse = z.infer<typeof SwitchFocusResponseSchema>;
